import { createFileRoute } from "@tanstack/react-router";

import { AppLogo } from "@/components/shared/app-logo";
import { PublicAppearanceProvider } from "@/providers/public-appearance.provider";
import { ProcessingNotice } from "@/features/legal/ProcessingNotice";

export const Route = createFileRoute("/privacy")({
  component: PrivacyPage,
});

function PrivacyPage() {
  return (
    <PublicAppearanceProvider className="min-h-screen w-full bg-background px-4 py-10">
      <div className="mx-auto w-full max-w-2xl space-y-8">
        <div className="flex justify-center">
          <a href="https://tuzidi.net" aria-label="Go to the TaxOS homepage">
            <AppLogo />
          </a>
        </div>
        <ProcessingNotice />
      </div>
    </PublicAppearanceProvider>
  );
}
